import axios from 'axios'
import store from '@/store'

var instance = axios.create()

instance.interceptors.request.use(
    config => {
        if (store.state.token) {
            config.headers.Authorization = `Bearer ${store.state.token}`
        }
        return config
    },
    err => {
        return Promise.reject(err)
    })
instance.interceptors.response.use(res => {
    if (res.data.code === 205 || res.data.code === 10000) {
        store.dispatch('doLogout')
        return Promise.reject('登录状态已过期')
    } else {
        return res
    }
}, err => {
    return Promise.reject(err)
})

export default instance